"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        background: "grey", //#fea #E7B55F #c87137
        borderRadius: 5,
        width: "100%",
        color: "#eee",
        outline: "none",
        border: "none",
        fontFamily: '"Bubblegum Sans", cursive',
        textDecoration: "none",
        fontSize: 26,
        padding: "12px 20px",
        display: "block",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        zIndex: 1,
        transition: "transform 0.25s ease-out",
        "&:hover": {
            transform: "scale(1.05)",
        },
        "&:focus, &:focus-visible": {
            textDecoration: "underline",
        },
    },
    triangle: {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        position: "absolute",
        zIndex: -1,
        background: "#a3a3a3", //#E7B55F #c87137 #A05A2C
        clipPath: "polygon(100% 0, 0 100%, 100% 100%)",
    },
    radio: {
        opacity: 0,
        position: "absolute",
        "&:not(:checked) ~div": {
            background: "#a3a3a3",
        },
    },
});
const Radiobutton = (_a) => {
    var { classes: givenClasses = {}, children, className, name, defaultChecked } = _a, rest = __rest(_a, ["classes", "children", "className", "name", "defaultChecked"]);
    const classes = useStyles();
    return (react_1.default.createElement("label", Object.assign({ className: (0, classnames_1.default)(classes.root, className) }, rest),
        react_1.default.createElement("input", { type: "radio", className: classes.radio, name: name, defaultChecked: defaultChecked }),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.triangle, givenClasses.triangle) }),
        children));
};
exports.default = Radiobutton;
